function Hyperdrive() {
  var _this = this;

  var elements = document.querySelectorAll('.hyperdrive');
  var windowHeight = Math.min(document.documentElement.clientHeight, window.innerHeight);
  var startYOffset = 75;
  var startZScrollAt = windowHeight * (75 / 100);

  var checkScenes = function checkScenes() {
    var bottomOfWindow = window.pageYOffset + windowHeight;
    var topOfWindow = window.pageYOffset; //Todo optimize, maybe if viewbounds would be able to be called in the constructor, but after the style is applied or something like that

    var viewBounds = Array.from(elements).map(function (element) {
      return {
        top: element.offsetTop,
        bottom: element.offsetTop + element.clientHeight
      };
    });
    viewBounds.forEach(function (bound, index) {
      if (bound.top <= bottomOfWindow && bound.bottom >= topOfWindow) {
        //Todo check if requestAnimation would be good to use here
        makeScene(index);
      } else if (bound.bottom < topOfWindow) {
        //We have scrolled throught the bound, make sure it is hidden to make it somewhat fail-safe
        hideScene(index);
      }
    });
  };

  var hideScene = function hideScene(index) {
    var element = elements[index];
    element.classList.add('hideScene');
  };

  var makeScene = function makeScene(index) {
    var element = elements[index];
    element.classList.remove('hideScene');
    element.scrolled = window.pageYOffset + windowHeight - element.offsetTop;
    element.scrolledViewportPercent = element.scrolled / windowHeight * 100;
    var yOffset = element.scrolledViewportPercent <= startYOffset ? -_this.startYOffset + element.scrolledViewportPercent : 0;
    element.style.setProperty("--zCamera", element.scrolledViewportPercent);
    element.style.setProperty("--yOffset", yOffset); //This way to blur feels abit process intensive, but can't figure out any other way to blur without avoiding ClearType pixel issue as described here https://stackoverflow.com/questions/39810389/css-brightnesss-filter-blurs-text

    if (element.getAttribute('blur') !== "false") {
      var blur = element.scrolled / windowHeight * 3;
      var children = element.querySelectorAll('.hyperdriveScene > div');
      children.forEach(function (child, index) {
        var blurAmount = (index + 1) * 3;
        var offset = 0.9;

        if (blur < blurAmount * offset) {
          if (child.style.filter === "none") child.style.filter = "blur(calc((".concat(blurAmount, " - var(--blur)) * 1px))");
          child.style.setProperty("--blur", blur);
        } else {
          child.style.filter = "none";
        }
      });
    }
  };

  var makeStyles = function makeStyles() {
    var generalStyles = "\n        .hyperdrive {\n            --yOffset: -75;\n            --parallax: -50;\n            --zCamera: 0;\n            --blur: 3;\n        \n            opacity:1;\n            transition:opacity 0.1s;\n        }\n        .hyperdrive.hideScene{\n            opacity:0;\n        }\n        .hyperdriveContainer {\n            height: 100%;\n            width: 100%;\n            position: fixed;\n            bottom: calc(var(--yOffset) * 1%); \n            left: 0;\n            perspective: 100vh;\n            perspective-origin: 50%;\n            will-change: perspective-origin;\n            transform: translate3d(0, 0, 0);\n        }\n        .hyperdriveScene {\n            height: 100%;\n            width: 100%;\n            position: absolute;\n            top: 0;\n            transform-style: preserve-3d;\n            transform: translateZ(calc(var(--zCamera) * 1vh));\n            will-change: transform;\n        }\n        .hyperdriveScene > *{\n            display: block;\n            width: auto;\n            max-width:100%;\n            position: absolute;\n            top: 50%;\n            left: 50%;\n            max-width:50%;\n        }\n        ";
    var styleSheet = document.createElement("style");
    styleSheet.type = "text/css";
    styleSheet.innerHTML = generalStyles;
    document.head.appendChild(styleSheet);
    elements.forEach(function (element, index) {
      var children = element.querySelector('.hyperdriveScene').children; //Checks if element is last on page

      if (element.offsetHeight + element.offsetTop >= document.body.offsetHeight) {
        element.style.height = "calc(".concat(children.length, " * 100vh)");
      } else {
        element.style.height = "calc(".concat(children.length, " * 100vh + 50vh)");
      }

      Array.from(children).forEach(function (child, index) {
        //Get attributes
        var x = child.getAttribute('x-position') ? child.getAttribute('x-position') : "50%";
        var y = child.getAttribute('y-position') ? child.getAttribute('y-position') : "50%";
        child.style.top = y;
        child.style.left = x;
        child.style.transform = "translate3D(-50%,-50%, calc(".concat(index + 1, " * -100vh + 50vh))");
        child.style.zIndex = "".concat(1000 - index);

        if (element.getAttribute('blur') !== "false") {
          child.style.filter = "blur(calc((".concat((index + 1) * 3, " - var(--blur)) * 1px))");
        }
      });
    });
  };

  var initialize = function initialize() {
    //Make styles
    makeStyles(); //Add actions

    window.addEventListener('scroll', checkScenes);
    window.dispatchEvent(new Event('scroll'));
    window.addEventListener('resize', function () {
      windowHeight = Math.min(document.documentElement.clientHeight, window.innerHeight);
    });
  };

  var object = new Object();
  object.initialize = initialize;
  object.initialize = initialize;
  return object;
}

export default Hyperdrive;